/*
 *
 * language-provider constants
 *
 */

export const CHANGE_LOCALE = "app/LanguageToggle/CHANGE_LOCALE";

export const BACKEND_ERROR_MESSAGES = [
  "EMAIL_ALREADY_EXISTS",
  "USER_NOT_FOUND",
  "INVALID_QUESTIONNAIRE_EMAIL",
  "EMAIL_NOT_FOUND",
  "ACCESS_DENIED",
  "NO_PENDING_EMAIL",
  "MFA_REQUIRED",
  "INVALID_FIREBASE_TOKEN",
  "INVALID_ROLE",
  "NO_COMPANY",
  "USER_DISABLED",
  "OWNER_DISABLED",
  "ONLY_OWNER_CAN_EDIT_FEES",
  "INVALID_TEAM_ROLE",
  "USER_ALREADY_HAS_COMPANY",
  "USER_ALREADY_HAS_PRACTICE_ROLE",
  "EXISTING_USER_AS_STAFF",
  "CANNOT_CREATE_ADMIN",
  "ASSISTANT_CANNOT_MANAGE_ADMIN",
  "ACCESS_CONTEXT_ASSISTANT_ONLY",
  "CANNOT_EDIT_COMPANY_NAME_OR_OWNER",
  "CANNOT_DELETE_OWNER_WITH_COMPANY",
  "IMAGE_FILE_TOO_LARGE",
  "INVITE_LINK_INVALID",
];
